import React from "react";
import { Banner, Button } from "@bookingcom/bui-react";
import { getImageAssetUrl } from "@bookingcom/bui-assets-react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";

import useClientMetrics from "hooks/useClientMetrics";
import useCreateUrl from "hooks/useCreateUrl";
import useUserAgent from "hooks/useUserAgent";

import flights_web_cat_fly_anywhere_filters_mdot from "utils/experiments/customer-aquisition/flights_web_cat_fly_anywhere_filters_mdot";
import flights_web_cat_fly_anywhere_filters_www from "utils/experiments/customer-aquisition/flights_web_cat_fly_anywhere_filters_www";

const FlyAnywhereBanner = () => {
  const i18n = useI18n();
  const { trackClientMetric } = useClientMetrics();
  const { createUrlWithApiPrefix } = useCreateUrl();
  const { isMobile } = useUserAgent();

  const handleClick = () => {
    trackClientMetric("fly_anywhere_click_banner");
    if (isMobile) {
      flights_web_cat_fly_anywhere_filters_mdot.goals.clicked_banner_5();
    } else {
      flights_web_cat_fly_anywhere_filters_www.goals.clicked_banner_5();
    }
  };

  return (
    <Banner
      title={i18n.trans(t("flights_cat_fly_anywhere_banner_header"))}
      text={i18n.trans(t("flights_cat_fly_anywhere_banner_body"))}
      startImage={{
        src: getImageAssetUrl({
          setName: "illustrations-traveller",
          assetName: "FlightsPlaneTopView"
        }),
        alt: ""
      }}
      dismissible={false}
    >
      <Button
        href={createUrlWithApiPrefix("/fly-anywhere")}
        variant="secondary"
        text={i18n.trans(t("flights_cat_fly_anywhere_banner_cta"))}
        onClick={handleClick}
      />
    </Banner>
  );
};

export default FlyAnywhereBanner;
